// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15Ohq","select":"styles_select__J8Ll4"};